// Thin KWF Admin topbar — pill nav for cross-section links + logout.
// Replaces the old Common/Navbar inside the dashboard shell.
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleAuth } from "../Redux/Slices/auth-slice";
import { Icon } from "./admin/_adminApi";

// Mirrors the artifact's cross-section nav: Dashboard / Family / Member / Property.
const LINKS = [
  { to: "/dashboard/dashboard_graph",  label: "Dashboard" },
  { to: "/dashboard/familydashboard",  label: "Family Listing" },
  { to: "/dashboard/memberdashboard",  label: "Member Listing" },
  { to: "/dashboard/donationdashboard", label: "Donation Listing" },
];

export default function AdminTopbar({ onBurger }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(toggleAuth({ isLogin: false, userInfo: null }));
    navigate("/");
    localStorage.removeItem("activeTab");
  };

  return (
    <header className="ad-top">
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        <button className="ad-mburger" onClick={onBurger} title="Open menu" aria-label="Open menu">
          <Icon.apps />
        </button>
        <nav className="ad-topnav">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={location.pathname === l.to || location.pathname.startsWith(l.to + "/") ? "active" : undefined}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="ad-top-right">
        <button className="ad-btn ghost sm" onClick={logout}><Icon.logOut />Logout</button>
      </div>
    </header>
  );
}
